<div class="flex overflow-hidden w-full h-full min-h-0 border rounded border-neutral-30">
  <!-- SIDEBAR MENU -->
  <div
    [ngClass]="{
      'w-[32px]': store.sidebarMenuCollapsed(),
      'w-[280px] min-w-52': !store.sidebarMenuCollapsed(),
    }"
    class="h-full border-r border-neutral-30 overflow-hidden transition-all duration-300 ease-in-out flex flex-col"
  >
    @if (!store.sidebarMenuCollapsed()) {
      <!-- Sidebar: single prompt source list and collapse toggle -->
        <div class="flex flex-row items-start w-full pt-2 pr-2 pl-2 gap-2 min-h-0 flex-1 overflow-y-auto">
        <ul class="flex-1 overflow-y-auto min-h-0">
          @for (category of store.promptCategories(); track category.name) {
            <li>
              <div class="flex cursor-pointer" (click)="toggleGroup(category.name)">
                <div class="w-full pb-2 pl-2">
                  <span [ngClass]="[category.iconStyle, '!font-normal', 'icon-16', 'pt-2', 'mr-1.5']"></span>
                  <span class="menu menu-2">{{ category.name }}</span>
                </div>

                <div class="flex justify-end pr-2">
                  <span
                    class="fa-icons icon-light icon-8 pt-3"
                    [ngClass]="{
                      'icon-chevron-up': !isGroupCollapsed(category.name),
                      'icon-chevron-down': isGroupCollapsed(category.name),
                    }"
                  ></span>
                </div>
              </div>

              <ul [ngClass]="{ 'block': !isGroupCollapsed(category.name), 'hidden': isGroupCollapsed(category.name) }">
                @for (prompt of category.prompts; track prompt.name) {
                  <li
                    class="w-full block cursor-pointer pl-8 py-1 hover:bg-bush-green-5"
                    [ngClass]="{ 'bg-bush-green-20 border-l-4 border-bush-green-80': isSelected(prompt, store.currentPrompt()) }"
                    (click)="usePrompt(prompt, store.useAllHouseholds())"
                  >
                    <div class="flex justify-between items-center">
                      <span class="sub-menu text-body-2 text-neutral-90">{{ getPromptName(prompt) }}</span>
                    </div>
                  </li>
                }
              </ul>
            </li>
          }

          <li
            class="w-full block cursor-pointer pl-2 py-1.5 text-body-2 text-inserv-100 hover:underline"
            (click)="store.triggerSendSuggestion()"
          >
            <div class="flex items-center leading-4">
              {{ 'iqboost.summary.suggestPromptLink' | translate }}
            </div>
          </li>
        </ul>

        <span 
          class="fa-icons icon-solid icon-sidebar icon-16 cursor-pointer text-bush-green-100 flex-shrink-0 pr-2 mt-2"
          (click)="toggleMenuSidebar()"
        ></span>
      </div>

      @if (!store.useAllHouseholds() && isAllHouseholdsEnabled()) {
        <div class="flex justify-center w-full pt-2">
          <button
            kendoButton
            themeColor="primary"
            fillMode="flat"
            class="h-[34px] rounded-md"
            [disabled]="store.isBusy()"
            (click)="store.switchToAllHouseholds()"
          >
            <div class="flex items-center leading-4">
              <img
                class="mr-2 w-4 text-bush-green-140"
                [ngClass]="{ 'opacity-50': store.isBusy() }"
                [src]="cdn + '/assets/images/multi-house.svg'"
                alt="multi-house"
              />

              {{ isSLE() 
                ? ('iqboost.summary.goToAllHouseholds.defaultVersion' | translate)
                : ('iqboost.summary.goToAllHouseholds.faVersion' | translate)
              }}
            </div>
          </button>
        </div>
      }

      <!-- CREDITS AVAILABLE -->
      @if (aiStore.isCreditSystemEnabled()) {
        <div class="min-h-[44px] m-3 border border-neutral-20 rounded-md bg-transparent flex items-center justify-between px-4">
          <span class="text-caption text-neutral-90">{{ 'aiHub.premiumFeatures.availableCredits' | translate }}</span>
          <span 
            class="text-caption text-neutral-90"
            [ngClass]="{
              'p-1 rounded-sm inline-block bg-bush-green-10': aiStore.isEarlyAccess(),
            }"
          >{{ remainingCredits() }}</span>
        </div>
      }
    }
    @else {
      <span 
        class="fa-icons icon-solid icon-sidebar icon-16 pl-2 pt-3 cursor-pointer text-bush-green-100"
        (click)="toggleMenuSidebar()"
      ></span>
    }
  </div>

  <!-- MAIN CONTENT -->
  <div class="flex-1 min-w-0 p-4"
    [ngClass]="{
      'bg-neutral-5': store.currentPrompt(),
      'bg-white': !store.currentPrompt(),
    }"
  >
    <!-- CURRENT PROMPTS -->
      <div class="flex flex-col h-full">
        @if(store.currentPrompt()) {
          <!-- Header -->
          <div class="flex-none mb-4 bg-neutral-5">
            <div class="flex justify-end w-full">
              @if (!store.useAllHouseholds()) {
                <!-- SAVE AS NOTE -->
                <button
                  kendoButton
                  themeColor="primary"
                  fillMode="flat"
                  (click)="saveNote()"
                  [disabled]="store.isBusy()"
                  class="max-w-60 min-w-32 h-[34px] rounded mr-5"
                >
                  <div class="flex items-center">
                    <span class="fa-icons icon-light icon-16 icon-file-plus mr-3"></span>
                    {{ 'iqboost.buttons.saveAsNote' | translate }}
                  </div>
                </button>
              }
              
              <!-- GENERATE DETAILED REPORT -->
              <button
                kendoButton
                themeColor="primary"
                fillMode="flat"
                [disabled]="store.isBusy()"
                (click)="generateViewDetailedReport()"
                class="max-w-60 min-w-32 h-[34px] rounded mr-5"
              >
                <div class="flex items-center">
                  <span class="fa-icons icon-light icon-16 icon-list mr-3"></span>
                  {{ 'iqboost.buttons.generateReport' | translate }}
                </div>
              </button>

              <!-- MAKE A QUESTION AND GOT TO CHAT WINDOW -->
              <ng-container
                *ngTemplateOutlet="askQuestionTemplate; context: {
                  containerClass: 'w-[30rem] justify-end',
                  invalidCssClass: !(questionControl.touched && questionControl.invalid) ? 'hidden' : '',
                }"
              ></ng-container>
            </div>

            <div class="flex items-center pt-1">
              <span class="maximizer-icons icon-iq-boost icon-24 pt-0.5 mr-3">
              </span>
              <h6 class="flex-1">
                  {{ 
                    (store.useAllHouseholds() ? 'iqboost.summary.titleFormatAllHouseholds' : 'iqboost.summary.titleFormat') 
                      | translate
                      | format: {
                        title: getPromptName(store.currentPrompt()),
                        entry: store.entryDisplayValue()
                      }
                }}
              </h6>
            </div>
          </div>

          <!-- Content -->
          <div class="w-full h-full px-4 pt-4 pb-2 overflow-y-auto rounded bg-white">
            @if (store.streamingStatusKey(); as statusKey) {
              <div class="flex items-center">
                <span class="maximizer-icons icon-iq-boost icon-20 mr-2 text-bush-green-140 animate-pulse"></span>
                <span class="text-body-2 font-semibold text-bush-green-140 animate-pulse pt-1">{{ statusKey | translate }}</span>
              </div>
            }
            @else if (store.loading()) {
              <ng-container *ngTemplateOutlet="thinkingTemplate"></ng-container>
            }
            @else {
              <span class="block text-body-2"
                [innerHTML]="store.aiResponse().summary | markdownRendering | clickableRef | entityKeyRef | deAnonymizer | createCRMObject | webSearchRef | safeHtml">
              </span>

              <!-- Footer -->
              <div class="flex items-center justify-between bg-neutral-5 mt-4 px-5">
                <button
                  kendoButton
                  themeColor="primary"
                  fillMode="flat"
                  [disabled]="store.isBusy()"
                  (click)="regenerateReport()"
                  class="w-32 h-[34px] rounded"
                >
                  <div class="flex items-center">
                    <span class="fa-icons icon-solid icon-16 icon-wand-magic-sparkles mr-3"></span>
                    {{ 'iqboost.buttons.regenerate' | translate }}
                  </div>
                </button>

                @if (store.currentPrompt() && !store.isBusy()) {
                  <ai-feedback
                    #feedback
                    extraIconClass="icon-light icon-22"
                    [source]="tracker.module"
                    [disableOnFeedback]="true"
                    (feedbackClicked)="store.computeFeedbackDisabled(store.aiResponse().summary)"
                    [metadata]="{ location: ViewType[store.viewType()] }"
                  ></ai-feedback>
                }
              </div>
            }
          </div>
        }
        @else {
          <div class="contents w-full h-full">
            <div class="flex flex-col items-center justify-center w-full h-full">
              <img
                class="w-[108px]"
                [src]="cdn + '/assets/images/empty-container.svg'"
                alt="Loading…"
              />
              <span class="text-body-2 text-neutral-70 whitespace-pre-line text-center mt-2">
                {{ (store.useAllHouseholds() ? 'iqboost.summary.selectPromptAllHouseholds' : 'iqboost.summary.selectPrompt') | translate }}
              </span>

              <!-- MAKE A QUESTION AND GOT TO CHAT WINDOW -->
              <ng-container
                *ngTemplateOutlet="askQuestionTemplate; context: {
                  containerClass: 'justify-center mt-5 w-3/4',
                  invalidCssClass: !(questionControl.touched && questionControl.invalid) ? 'invisible' : '',
                }"
              ></ng-container>
            </div>
          </div>
        }
      </div>   
  </div>

  <ng-template #thinkingTemplate>
    <div class="flex flex-col items-center justify-center w-full h-full space-y-2">
      <img
        class="w-[108px]"
        [src]="cdn + '/assets/images/empty-container.svg'"
        alt="Loading…"
      />
    </div>
  </ng-template>

  <ng-template
    #askQuestionTemplate
    let-containerClass="containerClass"
    let-invalidCssClass="invalidCssClass"
  >
    <div [class]="'flex ' + containerClass">
      <div class="block w-full">
        <kendo-combobox
          #combo
          class="block font-normal"
          [formControl]="questionControl"
          [data]="allPromptsGrouped()"
          valueField="text"
          textField="text"
          [allowCustom]="true"
          [clearButton]="false"
          [focusOnViewInit]="true"
          [showStickyHeader]="false"
          [valuePrimitive]="true"
          [placeholder]="'iqboost.buttons.askQuestionNoPrompt.' + textVersion() + '.' + (store.useAllHouseholds() 
            ? (textVersion() === 'faVersion' ? 'allHouseholds' : 'allContacts') 
            : (textVersion() === 'faVersion' ? 'singleHousehold' : 'singleContact')) 
            | translate"
          (click)="combo.toggle()"
          (blur)="questionControl.markAsTouched()"
          (input)="onComboInput($event, combo)"
          (keydown.enter)="submitQuestionFromControl(combo)"
        >
        </kendo-combobox>

        <span [class]="'mt-1 font-normal text-xs text-error block ' + invalidCssClass">
          {{ 'iqboost.summary.invalidQuestion' | translate }}
        </span>
      </div>

      <button
        kendoButton
        themeColor="primary"
        [disabled]="store.isBusy()"
        [attr.aria-label]="'iqboost.chat.askQuestions' | translate"
        (click)="submitQuestionFromControl(combo)"
        class="h-[34px] rounded ml-4"
      >
        <div class="flex items-center">
          <span class="fa-icons icon-solid icon-16 icon-up"></span>
        </div>
      </button>
    </div>
  </ng-template>
</div>
